module.exports = __webpack_public_path__ + "static/media/disclaimer.2f8763a4.md";